import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { injectIntl } from 'react-intl';
import _get from 'lodash/get';
import { callHistorySelectors, callHistoryActions, featureSelectors, accountSelectors } from '@lifesize/nucleus';
import actions from 'actions/Contact';
import ActivityFeed from 'components/ActivityFeed/ActivityFeed';
import { routes } from 'constants/Application';
import { selectContact } from 'utils/contact-utils';

const mapDispatchToProps = (dispatch, ownProps) => ({
  handleDeleteSelected: (callId) => dispatch(callHistoryActions.callHistoryDelete(callId)),
  handleVideoCall: (dialString) => dispatch(actions.startVideoCall(dialString)),
  handleAudioCall: (dialString) => dispatch(actions.startAudioCall(dialString)),
  handleChat: (contact) => {
    ownProps.history.push(routes.chat);
    dispatch(actions.chatWith(contact));
  },
  createContact: (contact) => {
    selectContact(contact, ownProps.history.push);
    dispatch(actions.createContact(contact));
  },
  selectContact: (contact, history) => dispatch(actions.selectContact(contact, true, history))
});

const chatOptionMapper = (call) => {
  const prereqCheck = call && call.isChattable && call.contact;
  // If invalid or non-chattable, leave as-is
  if (!prereqCheck) return call;

  if (prereqCheck && !call.contact.isMeeting) {
    // If it's not a meeting then return as-is, since it's a p2p or similar
    return call;
  }

  // If owned meeting, allow it as-is
  if (prereqCheck && call.contact.isMyMeeting) {
    return call;
  }

  // if user is moderator, do NOT show chat button.

  // Otherwise, unset isChattable if it is a meeting
  return { ...call, isChattable: false };
};

const mapStateToProps = (state) => {
  const callHistory = callHistorySelectors.callHistoryWeb(state).map(chatOptionMapper);
  const isFeedLoaded = true;
  const isChatEnabled =
    featureSelectors.isChatEnabled(state) && accountSelectors.getAccountFeatures(state).isChatEnabled;

  return {
    callHistory,
    hideContacts: _get(accountSelectors.getAccountFeatures(state), 'hideContacts', false),
    hideMeetings: _get(accountSelectors.getAccountFeatures(state), 'hideMeetings', false),
    hideRooms: _get(accountSelectors.getAccountFeatures(state), 'hideRooms', false),
    isChatEnabled,
    isFeedLoaded,
    totalMissedCalls: callHistorySelectors.totalNewMissedCalls(state)
  };
};

export default withRouter(injectIntl(connect(mapStateToProps, mapDispatchToProps)(ActivityFeed)));
